import { render, staticRenderFns } from "./SwitchLoginMethod.vue?vue&type=template&id=98717506&scoped=true&"
import script from "./SwitchLoginMethod.vue?vue&type=script&lang=js&"
export * from "./SwitchLoginMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98717506",
  null
  
)

export default component.exports